import React from 'react'

import { FilterCriteriaProvider } from 'src/public/components/default_template/filter_and_sort/FilterCriteriaContext'
import { MenuGroupingsProvider } from 'src/public/components/default_template/MenuGroupingsContext'
import { OnlineOrderingProviders } from 'src/public/components/online_ordering/OnlineOrderingProviders'
import { Channel } from 'src/public/js/siteUtilities'

export const EcommPageContexts = ({ children }: React.PropsWithChildren) => (
  <OnlineOrderingProviders channel={Channel.ECOMM} isOrderPage={false}>
    <MenuGroupingsProvider>
      <FilterCriteriaProvider>{children}</FilterCriteriaProvider>
    </MenuGroupingsProvider>
  </OnlineOrderingProviders>
)
